import { render, staticRenderFns } from "./charge-price-info.vue?vue&type=template&id=032d8e9c&scoped=true&"
import script from "./charge-price-info.vue?vue&type=script&lang=js&"
export * from "./charge-price-info.vue?vue&type=script&lang=js&"
import style0 from "./charge-price-info.vue?vue&type=style&index=0&id=032d8e9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d8e9c",
  null
  
)

export default component.exports